import { render, staticRenderFns } from "./SubInfoList.vue?vue&type=template&id=13034c4a"
import script from "./SubInfoList.vue?vue&type=script&lang=js"
export * from "./SubInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports